import React from 'react'

const LoanCalculator = () => {
  return (
    <section className="project">
      <p>This is the Loan Calculator!</p>
      <iframe title="loanCalculator" src="https://loan-calculator-jopemamo.netlify.app/" />
    </ section>
  )
}

export default LoanCalculator;